import { render, staticRenderFns } from "./QuestionBlock.vue?vue&type=template&id=2885e0f0&"
import script from "./QuestionBlock.vue?vue&type=script&lang=js&"
export * from "./QuestionBlock.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBlock.vue?vue&type=style&index=0&id=2885e0f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports